export default __webpack_public_path__ + "static/media/dj.2c1293bb.png";